module.exports = __webpack_public_path__ + "static/img/spring_huaPic.5dfea2e1.png";